import React from 'react';

import DebtFree from './debt-free.svg';
import LumpSumRepaymentTable from './lump-sum-repayment-table.svg';
import Shelf from './shelf.svg';

type ImageProps = React.HTMLAttributes<HTMLImageElement>;

export const DebtFreeImage = (props: ImageProps) => (
  <img
    {...props}
    src={DebtFree}
    alt="A house with a sign that says Debt Free. A man passes a bag of money to a woman, who passes him a document signifying that he is free from debt"
  />
);

export const LumpSumRepaymentTableImage = (props: ImageProps) => (
  <img
    {...props}
    src={LumpSumRepaymentTable}
    alt="Table showing the different options for lump sum repayments"
  />
);

export const ShelfImage = (props: ImageProps) => (
  <img
    {...props}
    src={Shelf}
    alt="Shelf with books. The wall shows post-its of a car, house and university graduation hat."
  />
);
